import { abortErrorWithoutStackContextRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/abortErrorWithoutStackContext';
import { nextRouteCancellationRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nextRouteCancellation';
import { nonErrorObjectNotFoundMatchingIdUnhandledRejectionRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nonErrorObjectNotFoundMatchingIdUnhandledRejection';
import { nonErrorOutOfMemoryUnhandledRejectionRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/nonErrorOutOfMemoryUnhandledRejection';
import { thirdPartyUwtUriErrorRule } from '@/shared/utils/sentry/clientIgnoreRules/rules/thirdPartyUwtUriError';
import { ClientSentryIgnoreRule } from '@/shared/utils/sentry/clientIgnoreRules/types';

export const CLIENT_SENTRY_IGNORE_RULES: readonly ClientSentryIgnoreRule[] = [
  abortErrorWithoutStackContextRule,
  nextRouteCancellationRule,
  nonErrorObjectNotFoundMatchingIdUnhandledRejectionRule,
  nonErrorOutOfMemoryUnhandledRejectionRule,
  thirdPartyUwtUriErrorRule,
];
